import {
  CustomerTypeIds,
  ITicketDescriptionFields,
  ITicketProductWithBundleType,
} from '@nx-ng/types';
import { parseCustomerTypeId } from '@nx-ng/util';

export const selectIdAndDescriptionsFromFares = (
  allFares: ITicketProductWithBundleType[]
): ITicketDescriptionFields => {
  if (!allFares) {
    return {};
  }
  return allFares.reduce(
    (agg: ITicketDescriptionFields, fare: ITicketProductWithBundleType) => {
      if (!fare.id) {
        return agg;
      }
      return {
        ...agg,
        [fare.id]: {
          ticketType: fare.bundleType,
          title: fare.description || '',
          description: formatFareSelectionPath(fare),
          customerTypeId:
            parseCustomerTypeId(fare.passengerType?.typeCode ?? '') ??
            CustomerTypeIds.Adult,
          customerType: fare.passengerType?.description ?? '',
          travelMethod: fare.ticketMode?.travelMethodName ?? '',
          travelTime: fare.ticketTime?.name ?? '',
          zone: fare.ticketArea?.travelArea ?? '',
          prices: fare.price || [],
          isDirectDebit: fare.isDirectDebit || false,
          mTicketID: fare.mTicketID || '',
          swiftTicketID: fare.swiftTicketID || '',
          alias: fare.swiftTicketID ? fare.swiftTicketID : fare.mTicketID,
          termDateFrom: fare?.termDates?.termDateFrom || '',
          termDateTo: fare?.termDates?.termDateTo || '',
          noDays: fare?.noOfDays || 0,
        },
      };
    },
    {} as ITicketDescriptionFields
  );
};

export const formatFareSelectionPath = (fare: ITicketProductWithBundleType) => {
  if (fare.bundleType === 'flexible') {
    return 'flexible_tickets_description'; //key from i18
  }
  if (fare.bundleType === 'payAsYouGo') {
    return 'payg_tickets_description'; //key from i18
  } else {
    return formatSearchSelectionPath({
      customerType: fare?.passengerType?.description,
      travelArea: fare?.ticketArea?.travelArea,
      travelMethod: fare?.ticketMode?.travelMethodName,
      travelTime: fare?.ticketTime?.name,
    });
  }
};

export const formatSearchSelectionPath = ({
  customerType,
  travelArea,
  travelMethod,
  travelTime,
}: {
  customerType?: string;
  travelArea?: string;
  travelMethod?: string;
  travelTime?: string;
}): string => {
  let response = '';
  if (customerType) {
    response += `${customerType}, `;
  }
  if (travelArea) {
    response += `${travelArea}, `;
  }
  if (travelMethod) {
    response += `${travelMethod}, `;
  }
  if (travelTime) {
    response += `${travelTime}`;
  }

  return response.lastIndexOf(', ') === response.length - 1
    ? response.substr(0, response.length - 1)
    : response;
};
